import React, { SVGAttributes } from 'react';

export const ChevronIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4796_1110)">
      <path
        d="M14.1395 8.5447C14.1105 8.4815 14.0618 8.42759 13.9994 8.38974C13.937 8.3519 13.8638 8.33182 13.789 8.33203H6.21105C6.13625 8.33182 6.06305 8.3519 6.00068 8.38974C5.93831 8.42759 5.88956 8.4815 5.86057 8.5447C5.83327 8.60883 5.82635 8.67873 5.8406 8.74632C5.85485 8.81391 5.88969 8.87642 5.94109 8.92662L9.73008 12.3987C9.8025 12.4628 9.8993 12.4987 10 12.4987C10.1008 12.4987 10.1976 12.4628 10.27 12.3987L14.059 8.92662C14.1104 8.87642 14.1452 8.81391 14.1595 8.74632C14.1737 8.67873 14.1668 8.60883 14.1395 8.5447Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4796_1110">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
